// src/pages/CourseDetails.jsx
import React from "react";
import { useParams, Link } from "react-router-dom";

const courseData = {
  "cyber-security": {
    title: "Cyber Security Internship",
    description:
      "Dive into real-world cybersecurity tasks like vulnerability analysis, system hardening, and ethical hacking fundamentals.",
    duration: "4 Weeks",
    mode: "Remote",
    topics: [
      "Network Security Basics",
      "OWASP Top 10",
      "Ethical Hacking Tools",
      "Mini Security Audit Project",
    ],
  },
  "python-programming": {
  title: "Python Programming Internship",
  description:
    "Start your programming journey with Python. This internship includes hands-on coding exercises, file handling, basic data structures, and a mini project for real-world application.",
  duration: "6 Weeks",
  mode: "Remote",
  topics: [
    "Python Syntax & Variables",
    "Control Flow (if-else, loops)",
    "Functions & Modules",
    "Lists, Tuples, Dictionaries",
    "File Handling",
    "Error Handling",
    "Basic Object-Oriented Programming",
    "Mini Project: Automation Script or CLI Tool",
  ]
},
  "ai-ml": {
    title: "AI & ML Internship",
    description:
      "Learn core ML concepts, data preprocessing, and build your own models with Python and Scikit-learn.",
    duration: "12 Weeks",
    mode: "Remote",
    topics: [
      "Python for AI/ML",
      "Machine Learning Basics",
      "Classification & Clustering",
      "Feature Engineering & Data Preprocessing",
      "Natural Language Processing (NLP)",
      "Deep Learning Basics",
      "Convolutional Neural Networks (CNN)",
      "Model Optimization",
      "Mini ML Project1",
      "Deployment",
      "Mini ML Project2",
      "Final Review",

    ],
  },
  "web-dev": {
    title: "Web Development Internship",
    description:
      "Master frontend and backend basics, and build your own full-stack web app using React and Node.js.",
    duration: "4 Weeks",
    mode: "Hybrid",
    topics: [
      "HTML, CSS, JS Basics",
      "React + Tailwind",
      "APIs & Express.js",
      "Capstone Project",
    ],
  },
  "blockchain": {
    title: "Blockchain Internship",
    description:
      "Explore the decentralized world: learn blockchain fundamentals, Ethereum, smart contracts and DApps.",
    duration: "6 Weeks",
    mode: "Remote",
    topics: [
      "Blockchain Basics",
      "Ethereum & MetaMask",
      "Smart Contracts",
      "Mini DApp Project",
    ],
  },
};

const CourseDetails = () => {
  const { id } = useParams();
  const course = courseData[id];

  if (!course) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-white via-gray-100 to-gray-200 text-gray-900 flex items-center justify-center">
        <h2 className="text-xl font-semibold">Course not found.</h2>
      </div>
    );
  }

  return (
     <main className="relative min-h-screen bg-gradient-to-br from-white via-gray-100 to-gray-200 px-6 py-20 text-gray-900 overflow-hidden">

      

      <article className="max-w-3xl mx-auto bg-white/80 backdrop-blur-md p-8 rounded-xl shadow-xl">
        <h2 className="text-4xl font-extrabold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent mb-4">
          {course.title}
        </h2>
        <p className="text-gray-700 mb-6">{course.description}</p>

        <section className="mb-6 space-y-2">
          <p>
            <span className="font-semibold text-gray-900">📆 Duration:</span>{" "}
            {course.duration}
          </p>
          <p>
            <span className="font-semibold text-gray-900">🌐 Mode:</span>{" "}
            {course.mode}
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 mb-3">📚 Topics Covered</h3>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            {course.topics.map((topic, i) => (
              <li key={i}>{topic}</li>
            ))}
          </ul>
        </section>

        <div className="flex flex-wrap gap-4 mt-8">
          <Link
            to={`/courses/${id}/modules`}
            className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2 rounded-lg font-semibold transition"
          >
            📘 View Modules
          </Link>
          <Link
            to="/apply"
            className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-2 rounded-lg font-semibold transition"
          >
            📝 Apply Now
          </Link>
        </div>
      </article>
    </main>
  );
};

export default CourseDetails;
